module.exports = __webpack_public_path__ + "static/media/13.f200a61e.jpg";